"use client";
import { Button, Stack, Tooltip, useTheme } from "@mui/material";

function ButtonComponent({
  variant = "contained",
  type = "submit",
  children,
  buttonStyle = {},
  toolTipTitle,
  stackWidth,
  buttonPlacement,
  ...props
}) {
  const theme = useTheme();

  let sx = {
    padding: "1rem 1.5rem",
    borderRadius: "0.5rem",
    width: stackWidth || "100%",
    fontSize: { xs: 12, sm: 14 },
    ...buttonStyle,
  };
  if (type === "submit") {
    sx = {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.pale.main,
      textTransform: "capitalize",
      "&:hover": {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.pale.main,
        cursor: "pointer",
        boxShadow: "2px 2px 2px 2px rgba(0, 0, 0, 0.3)",
      },
      ...sx,
    };
  } else if (type === "reset") {
    sx = {
      color: theme.palette.primary.pale,
      textTransform: "capitalize",
      ...sx,
    };
  }
  return (
    <Stack
      width={stackWidth || "100%"}
      direction={"row"}
      alignItems={"center"}
      justifyContent={buttonPlacement || "center"}
    >
      <Button
        disableRipple
        disableTouchRipple
        disableFocusRipple
        variant={variant}
        type={type}
        sx={sx}
        {...props}
      >
        {children}
      </Button>
    </Stack>
  );
}

export default ButtonComponent;
